// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#order {}





#order section {
  margin-bottom: 50px;

}


#order .labels {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}

#order label.select {
  position: relative;
  display: flex;
  line-height: 1.3;
  padding: 10px;
  text-align: center;
  border-radius: 15px;
  flex-direction: column;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  background-size: cover;
  color: black;
  height: 70px;
  justify-content: center;
}

#order label.select strong {
  display: block;
}


#order .collecte label.select {
  background-image: url('https://laffairearepasser.fr/msmedias/petales/petale-bleu-uni.png');
}

#order .restitution label.select {
  background-image: url('https://laffairearepasser.fr/msmedias/petales/petale-vert-uni.png');
}


#order label .check {
  position: absolute;
  right: 10px;
  top: 20px;

}




#order label.select img {
  max-height: 35px;
  margin-bottom: 0.5rem;
}

#order label.select input {
  display: none;
}



#order ul.categorie-products {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}

#order ul.categorie-products li {
  flex: 0 0 180px;
  border: 1px solid #ddd;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  text-align: center;
  padding: 7px;
  margin: 0 10px 10px 0;
  font-size: 0.8rem;
}

#order ul.categorie-products .input-group {
  max-width: 120px;
  margin: 2px auto 0;
}



@media screen and (min-width: 576px) {
  #order label.select {
    flex: 0 0 165px;
    width: 165px;
    height: 84px;
    margin: 0 30px 30px 0;
    padding-right: 30px;
  }

}


@media screen and (max-width: 575px) {
  #order .labels {
    justify-content: space-between;
  }

  #order label.select {
    flex: 0 0 150px;
    width: 150px;
    height: 77px;
    margin: 0 10px 15px 0;
  }

  #order label.select svg {
    max-width: 25px;
  }

  #order .buttons-section {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/orders/order.css"],"names":[],"mappings":"AAAA,QAAQ;;;;;;AAMR;EACE,mBAAmB;;AAErB;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,0FAA0F;AAC5F;;AAEA;EACE,0FAA0F;AAC5F;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;;AAEX;;;;;AAKA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;;AAIA;EACE;IACE,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;EACrB;;AAEF;;;AAGA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["#order {}\r\n\r\n\r\n\r\n\r\n\r\n#order section {\r\n  margin-bottom: 50px;\r\n\r\n}\r\n\r\n\r\n#order .labels {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: start;\r\n}\r\n\r\n#order label.select {\r\n  position: relative;\r\n  display: flex;\r\n  line-height: 1.3;\r\n  padding: 10px;\r\n  text-align: center;\r\n  border-radius: 15px;\r\n  flex-direction: column;\r\n  user-select: none;\r\n  cursor: pointer;\r\n  background-size: cover;\r\n  color: black;\r\n  height: 70px;\r\n  justify-content: center;\r\n}\r\n\r\n#order label.select strong {\r\n  display: block;\r\n}\r\n\r\n\r\n#order .collecte label.select {\r\n  background-image: url('https://laffairearepasser.fr/msmedias/petales/petale-bleu-uni.png');\r\n}\r\n\r\n#order .restitution label.select {\r\n  background-image: url('https://laffairearepasser.fr/msmedias/petales/petale-vert-uni.png');\r\n}\r\n\r\n\r\n#order label .check {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 20px;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n#order label.select img {\r\n  max-height: 35px;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n#order label.select input {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n#order ul.categorie-products {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n#order ul.categorie-products li {\r\n  flex: 0 0 180px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 7px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  text-align: center;\r\n  padding: 7px;\r\n  margin: 0 10px 10px 0;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n#order ul.categorie-products .input-group {\r\n  max-width: 120px;\r\n  margin: 2px auto 0;\r\n}\r\n\r\n\r\n\r\n@media screen and (min-width: 576px) {\r\n  #order label.select {\r\n    flex: 0 0 165px;\r\n    width: 165px;\r\n    height: 84px;\r\n    margin: 0 30px 30px 0;\r\n    padding-right: 30px;\r\n  }\r\n\r\n}\r\n\r\n\r\n@media screen and (max-width: 575px) {\r\n  #order .labels {\r\n    justify-content: space-between;\r\n  }\r\n\r\n  #order label.select {\r\n    flex: 0 0 150px;\r\n    width: 150px;\r\n    height: 77px;\r\n    margin: 0 10px 15px 0;\r\n  }\r\n\r\n  #order label.select svg {\r\n    max-width: 25px;\r\n  }\r\n\r\n  #order .buttons-section {\r\n    text-align: center;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
